<template>
  <div
    v-if="
      simulation.energy === 'gas' || ['cooking', 'industrial'].includes(usageId)
    "
    class="mrgt md-mrgt+ lg-mrgt++"
  >
    <div class="container">
      <div class="media">
        <div class="media__left">
          <Icon id="info" class="icon--150 text-brand" />
        </div>
        <div class="media__body">
          <h4 class="mrgt0">{{ gettext('Déjà client Energiapro?') }}</h4>
          <a
            :href="`https://web2.holdigaz.ch/espace-client/views/view.login.php?form=biogaz_simulateur&usage=${usageId}`"
            class="text-bold text-medium"
          >
            {{ gettext('Vers l’Espace client')
            }}<Icon id="chevron-right" class="icon--75 mrgl--" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatNumber } from '@/helpers/utils';
import { onBeforeRouteLeave, useRouter } from 'vue-router';
import { useSimulation } from '@/composables/useSimulation';

const {
  simulation,
  product,
  usageId,
  formPluginElement,
  mobilityTotal,
  shouldIncludePower,
  usage,
} = useSimulation();

const router = useRouter();

const fillInFormFields = () => {
  const form = formPluginElement.value;
  const formUsageField = form.querySelector('[name="simulator-usage"]');
  const formConsumptionField = form.querySelector(
    '[name="simulator-consumption"]'
  );
  const formPowerField = form.querySelector('[name="simulator-power"]');
  const formProductField = form.querySelector('[name="simulator-product"]');
  const formBiogazField = form.querySelector('[name="simulator-biogaz"]');

  if (formUsageField) {
    formUsageField.value = usage.value.name;
  }

  if (formConsumptionField) {
    if (usageId.value === 'mobility') {
      formConsumptionField.value = `${formatNumber(mobilityTotal.value)} kg`;
    } else {
      formConsumptionField.value = `${formatNumber(
        simulation.consumption
      )} kWh`;
    }
  }

  if (formPowerField) {
    if (shouldIncludePower.value && simulation.power > 0) {
      formPowerField.value = `${formatNumber(simulation.power)} KW`;
      formPowerField.closest('.form-group').removeAttribute('hidden');
    } else {
      formPowerField.value = '';
      formPowerField.closest('.form-group').setAttribute('hidden', true);
    }
  }

  if (formProductField) {
    formProductField.value = product.value.name;
  }

  if (formBiogazField) {
    formBiogazField.value = product.value.label;
  }
};

if (product.value) {
  formPluginElement.value.removeAttribute('hidden');
  fillInFormFields();
} else {
  router.push({ name: 'products' });
}

onBeforeRouteLeave(() => {
  formPluginElement.value.setAttribute('hidden', true);
});
</script>
